<template>
  <v-container>
    <DesktopTopPart />
    <v-row>
      <v-col class="white px-0">
        <v-container fluid>
          <v-row>
            <DesktopLeftSidebar />
            <v-col class="grow">
              <div
                class="right-col"
                id="content-area"
                style="width: 100%; margin-left: 0"
              >
                <div v-if="galleriesByArticleId[selectedArticle._id]">
                  <ObjectImages
                    :images="articleImages"
                    :compact="isMobileView"
                    :img-folder="'galleryImages/large'"
                  />
                </div>
                <div v-html="selectedArticle['content_' + lang] || selectedArticle['content_en']" />
                <BookingForm v-if="showBookingForm" />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import DesktopLeftSidebar from '@/components/Views/Layout/DesktopLeftSidebar'
import DesktopTopPart from '@/components/Views/Layout/DesktopTopPart'
import PageFooter from '@/components/App/_PageFooter'
import ObjectImages from '@/components/ObjectImages/ObjectImages'
import BookingForm from '@/components/Forms/BookingForm'
import state from '@/store/state'
import sharedComputed from '@/methods/sharedComputed'
import { createHelpers } from 'vuex-map-fields'
import sharedMethods from '@/methods/sharedMethods'
import articleComputed from '@/methods/articleComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ArticleDesktop',

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  components: {
    BookingForm,
    ObjectImages,
    PageFooter,
    DesktopTopPart,
    DesktopLeftSidebar,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
